export const SignoutIcon = ({ width = 32, height = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path d="M18.3601 7.14001C19.6185 8.3988 20.4754 10.0025 20.8224 11.7482C21.1694 13.494 20.991 15.3034 20.3098 16.9478C19.6285 18.5921 18.4749 19.9976 16.9949 20.9864C15.515 21.9752 13.775 22.5029 11.9951 22.5029C10.2152 22.5029 8.47527 21.9752 6.99529 20.9864C5.51532 19.9976 4.36176 18.5921 3.68049 16.9478C2.99921 15.3034 2.82081 13.494 3.16784 11.7482C3.51487 10.0025 4.37174 8.3988 5.63012 7.14001" stroke="url(#paint0_linear_18814_7327)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2.5V12.5" stroke="url(#paint1_linear_18814_7327)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_18814_7327" x1="2.99512" y1="14.822" x2="20.9961" y2="14.822" gradientUnits="userSpaceOnUse">
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
      <linearGradient id="paint1_linear_18814_7327" x1="12" y1="7.50034" x2="13.0001" y2="7.50034" gradientUnits="userSpaceOnUse">
        <stop stopColor="#000"/>
        <stop offset="1" stopColor="#000"/>
      </linearGradient>
    </defs>
  </svg>
);
